export class ValidationResult{
    constructor(isvalid:boolean,data:any = null) {
        this.isValid = isvalid;
        this.data = data;
    }
    isValid:boolean;
    data:any;
}